
export class AviationEventPhoto {
  /**
   * Unique identifier for this record in the database
   */
  photoId: number;

  /**
   * path to original photo file
   */
  originalPhotoPath: string;

  /**
   * path to large version of photo
   */
  largePhotoPath: string;

  /**
   * path to medium version of photo
   */
  previewPhotoPath: string;

  /**
   * path to small version of photo
   */
  thumbnailPhotoPath: string;

  /**
   * Date the review was added
   */
  uploadedDate: Date;

  /**
   * MCID of the user who created the photo
   */
  uploadedBy: string;

  /**
   * Parses review
   * @param data {any} Review data as returned by API
   * @return {Review} Parsed review
   */
  static parse(data: any): AviationEventPhoto {
    return {
      photoId: data.photoId,
      originalPhotoPath: data.originalPhotoPath,
      largePhotoPath: data.largePhotoPath,
      previewPhotoPath: data.previewPhotoPath,
      thumbnailPhotoPath: data.thumbnailPhotoPath,
      uploadedBy: data.uploadedBy,
      uploadedDate: data.uploadedDate ? new Date(data.uploadedDate) : null
    };
  }
}
